import "./HowItWorks.css";

const HowItWorks = () => {

    return (

        <div className="how-card">

            <h3>

                How Image AI works?

            </h3>

            <div className="how-step">

                <div className="how-number">
                    1
                </div>

                <div>

                    <h4>Create</h4>

                    <p>

                        Describe what you want, and watch AI bring your idea to life.

                    </p>

                </div>

            </div>

            <div className="how-step">

                <div className="how-number">
                    2
                </div>

                <div>

                    <h4>Perfect</h4>

                    <p>

                        Chat with AI to tweak specific details while keeping the rest intact.

                    </p>

                </div>

            </div>

        </div>

    );

};

export default HowItWorks;